import { createSelector } from "reselect";
import { initialState } from "./reducer";
/**
 * Direct selector to the patientOverviewPage state domain
 */

const selectPatientOverviewPageDomain = state =>
  state.get("patientOverviewPage", initialState);

/**
 * Other specific selectors
 */

export const makeSelectPageNumbers = () =>
  createSelector(selectPatientOverviewPageDomain, subState =>
    subState.get("pageNumbers"),
  );

/**
 * Default selector used by PatientOverviewPage
 */

const makeSelectPatientOverviewPage = () =>
  createSelector(selectPatientOverviewPageDomain, substate => substate.toJS());

export default makeSelectPatientOverviewPage;
export { selectPatientOverviewPageDomain };
